import { useEffect } from "react";

import { useKeycloak } from "@king-ict/eupisi-ui/hooks";
import { useRouteMatch } from "react-router";

import { useTypedSelector } from "../../app/rootReducer";
import { useBusinessRule } from "../../hooks/businessRule/useBusinessRule";
import { authRoute } from "../../routes/routes";

export interface MatchParams {
  requestId: string;
  id: string;
}

export interface NavbarProps {
  setImpairedStyle: () => void;
  removeImpairedStyle: () => void;
}

export const Navbar = ({
  setImpairedStyle,
  removeImpairedStyle,
}: NavbarProps) => {
  const { keycloak } = useKeycloak();
  const user = useTypedSelector((state) => state.application.user);
  const authMatch = useRouteMatch<MatchParams>(authRoute);

  useEffect(() => {
    function mutationCallback(mutationRecord: MutationRecord[]) {
      if (mutationRecord && mutationRecord.length > 0) {
        const addedNodes = mutationRecord[0].addedNodes;
        if (addedNodes) {
          document
            .getElementById("nonimpaired")
            ?.addEventListener("click", (e) => {
              e.preventDefault();
              setImpairedStyle();
            });
          document
            .getElementById("impaired")
            ?.addEventListener("click", (e) => {
              e.preventDefault();
              removeImpairedStyle();
            });
          document
            .getElementById("nondyslexic")
            ?.addEventListener("click", (e) => {
              e.preventDefault();
              removeImpairedStyle();
            });
          document.getElementById("larger")?.addEventListener("click", (e) => {
            e.preventDefault();
            largerFont();
          });
          document.getElementById("default")?.addEventListener("click", (e) => {
            e.preventDefault();
            defaultFont();
          });
          document.getElementById("smaller")?.addEventListener("click", (e) => {
            e.preventDefault();
            smallerFont();
          });
        }
      }
    }

    const largerFont = () => {
      const currentFontSize = document.documentElement.style.fontSize;
      let currentFont = 100;
      if (currentFontSize != null && currentFontSize !== "") {
        const currentFontPercentage = currentFontSize.split("%")[0];
        currentFont = +currentFontPercentage;
      }

      if (currentFont < 120) {
        document.documentElement.style.fontSize = currentFont + 5 + "%";
      }
    };

    const defaultFont = () => {
      document.documentElement.style.fontSize = "100%";
    };

    const smallerFont = () => {
      const currentFontSize = document.documentElement.style.fontSize;
      let currentFont = 100;
      if (currentFontSize != null && currentFontSize !== "") {
        const currentFontPercentage = currentFontSize.split("%")[0];
        currentFont = +currentFontPercentage;
      }

      if (currentFont > 80) {
        document.documentElement.style.fontSize = currentFont - 5 + "%";
      }
    };

    const observer = new MutationObserver(mutationCallback);

    const config = {
      childList: true,
    };

    const target = document.getElementsByClassName("egradani_traka-holder");
    observer.observe(target[0], config);

    if (document.cookie.indexOf("cookieImpaired") !== -1) {
      setImpairedStyle();
    } else if (document.cookie.indexOf("cookieDyslexic") !== -1) {
      removeImpairedStyle();
    }

    return () => {
      observer.disconnect();
    };
  });

  const { isLoginEnabled } = useBusinessRule();

  useEffect(() => {
    const script = document.createElement("script");

    if (user.userId > 0 && keycloak.authenticated) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const forLegalIps = urlParams.get("forLegalIps");
      const forPersonOib = urlParams.get("person");

      script.src = `${process.env.REACT_APP_NIAS_NAVBAR}?messageId=${
        user.niasMessageId
      }&amp;navToken=${
        user.niasNavigationToken
      }&logout_url=${keycloak.createLogoutUrl({
        redirectUri: process.env.REACT_APP_WEB_PUBLIC,
      })}`;

      if (!!forLegalIps) {
        const forLegalIzvorReg = urlParams.get("forLegalSource");
        const toLegalIps = urlParams.get("toLegalIps");
        const toLegalIzvorReg = urlParams.get("toLegalSource");

        script.src += `&ForLegalIps=${forLegalIps}&ForLegalIzvor_reg=${forLegalIzvorReg}&ToLegalIps=${toLegalIps}&ToLegalIzvor_reg=${toLegalIzvorReg}`;
      } else if (!!forPersonOib) {
        script.src += `&ForPersonOib=${forPersonOib}`;
      }
    } else {
      script.src = `${process.env.REACT_APP_NIAS_NAVBAR}?show_login_button=false&show_font_resize=false`;
    }

    script.src +=
      "&change_entity_url=" +
      encodeURIComponent(
        `${process.env.REACT_APP_WEB_PUBLIC}?person={ForPersonOib}&forLegalIps={ForLegalIps}&forLegalSource={ForLegalIzvor_reg}&toLegalIps={ToLegalIps}&toLegalSource={ToLegalIzvor_reg}`
      );

    script.addEventListener("load", function (e) {
      document
        .getElementsByClassName("zgl-button log_in")[0]
        ?.addEventListener("click", (e) => {
          e.preventDefault();
          keycloak.login({ idpHint: "saml-nias" });
        });
      document.getElementsByClassName("zgl-button log_out")[0]?.setAttribute(
        "href",
        keycloak.createLogoutUrl({
          redirectUri: process.env.REACT_APP_WEB_PUBLIC,
        })
      );
    });

    script.id = "nias-script";
    script.async = true;

    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [
    keycloak,
    user,
    authMatch,
    isLoginEnabled,
    setImpairedStyle,
    removeImpairedStyle,
  ]);

  return (
    <>
      <div className="egradani_traka-holder"></div>
    </>
  );
};
